import { PORTAL } from "src/constants/AppConstants";
const appSettings = {
    'appId':'55',
    'appName':'mjemonitoring'
}

export default appSettings;